// extracted by mini-css-extract-plugin
export var paginationContainer = "_ag-0";